import { useRouteTracker } from './useRouteTracker'

export default function RouteTracker() {
  useRouteTracker()
  return null
}
